import { useState, useEffect } from 'react';
import { finance } from '../utils/data';
import { tableHeader, tableData, title } from '../utils/style';

function Payment() {
    const [ payments, setPayments ] = useState([]);

    useEffect(() => {
        const data = [];
        for(let i = 0; i < 10; i++){
            data.push(finance.payments[0])
        }
        console.log(data)
        setPayments(data)
    }, [])

    return(
        <div className="p-4">
            <div className={title}>Payments</div>
            <div>
                <table className='w-full'>
                    <thead>
                        <tr>
                            <th className={ tableHeader }>Service Type</th>
                            <th className={ tableHeader }>Appointment Date</th>
                            <th className={ tableHeader }>Job Order No.</th>
                            <th className={ tableHeader }>Payment Status</th>
                        </tr>
                    </thead>
                    <div className='mt-2 h-4 w-full'></div>
                    <tbody>
                        {
                            payments.map((payment, index) => 
                            <><tr key={index} className="border border-gray-200">
                                <td className={ tableData }>{payment.serviceType}</td>
                                <td className={ tableData }>{payment.date}</td>
                                <td className={ tableData }>{payment.jobOrderNo}</td>
                                <td className={ tableData }>{payment.paymentStatus}</td>
                            </tr>
                            <div className='mt-2 w-full'></div></>)
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Payment;